import { render, staticRenderFns } from "./ShippingInfo.vue?vue&type=template&id=17f1db70"
import script from "./ShippingInfo.vue?vue&type=script&lang=js"
export * from "./ShippingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports